import { styled, type SxProps, type Theme } from "@mui/material/styles";

export const TAB_SX: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  gap: 0.75,
  height: "100%",
  minHeight: 0,
};

export const BODY_SX: SxProps<Theme> = { display: "flex", flex: 1, minHeight: 0, gap: 2.5 };

export const FIELDS_SX: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: 2,
  width: 288,
  flexShrink: 0,
};

export const FIELD_LIST_SX: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  gap: 1.25,
  width: "100%",
};

/** The row action sits beside the control, so it lines up with the input rather than its label. */
export const FIELD_ROW_SX: SxProps<Theme> = { display: "flex", alignItems: "flex-end", gap: 1.25 };

export const FIELD_SX: SxProps<Theme> = { flex: 1, minWidth: 0 };

export const PREVIEW_SX: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  flex: 1,
  minWidth: 0,
  gap: 4,
  overflowY: "auto",
};

export const FAMILY_SX: SxProps<Theme> = { display: "flex", flexDirection: "column", gap: 1 };

export const FAMILY_HEADER_SX: SxProps<Theme> = { display: "flex", alignItems: "center", gap: 1 };

export const WEIGHTS_SX: SxProps<Theme> = { display: "flex", flexDirection: "column", gap: 2 };

export const WEIGHT_SX: SxProps<Theme> = { display: "flex", flexDirection: "column", gap: 0.75 };

/**
 * The one place a component sets its own `fontFamily`: the sample exists to render the client's font,
 * not the app's Figtree.
 */
export const FontSample = styled("p", {
  shouldForwardProp: (prop) => prop !== "sampleFontFamily" && prop !== "sampleFontWeight",
})<{ sampleFontFamily: string; sampleFontWeight: number }>(({ sampleFontFamily, sampleFontWeight }) => ({
  margin: 0,
  fontFamily: sampleFontFamily,
  fontWeight: sampleFontWeight,
  fontSize: 20,
  lineHeight: "24px",
}));
